/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Dialect_Not_ReadyInputs */

const cs_import_dialect_not_ready = /** @type {(inputs: Import_Dialect_Not_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`není připraveno`)
};

const en_import_dialect_not_ready = /** @type {(inputs: Import_Dialect_Not_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`not ready`)
};

/**
* | output |
* | --- |
* | "not ready" |
*
* @param {Import_Dialect_Not_ReadyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_dialect_not_ready = /** @type {((inputs?: Import_Dialect_Not_ReadyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Dialect_Not_ReadyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_dialect_not_ready(inputs)
	return cs_import_dialect_not_ready(inputs)
});